import React from 'react';
import { Card } from '../Card';
import s from './CardList.module.css';
import { DealDto } from '../../../../shared/swagger/client/api-client';

export interface CardItem {
  id: string | number;
  imageUrl: string;
  title: string;
  price: number | string;
  alt?: string;
}

interface CardListProps {
  items: DealDto[];
  onCardClick?: (id: DealDto) => void;
  className?: string;
}

export const CardList: React.FC<CardListProps> = ({ 
  items, 
  onCardClick,
  className
}) => {
  return (
    <div className={`${s.cardList} ${className || ''}`}>
      {items.map((item) => (
        <Card
          key={item.id}
          imageUrl={item.primaryImage}
          title={item.title || `${item.make} ${item.model}`}
          price={item.price}
          alt={item.title}
          onClick={() => onCardClick && onCardClick(item)}
        />
      ))}
    </div>
  );
};

export default CardList;
